module.exports = __webpack_public_path__ + "static/media/active-days-video.38dd9421.mp4";